import React from "react";
import Certificate from "../components/Certifications/Certificate";

const Certifications = () => {
  return (
    <>
      <Certificate/>
    </>
  );
};

export default Certifications;
